import { DirectLine } from 'botframework-directlinejs';
import { BotActivity } from '../../botTypes';
import { AdsCopilotDirectLine } from '../direct-line-provider/ads-copilot-direct-line';

/**
 * Examines a bot activity and determines if it is something that needs to be shared across both Copilot chat and the rest of the app.
 * @param activity {BotActivity} The bot activity to examine.
 * @returns {boolean} True if the activity should be accessed by other parts of the app, false if the activity is only used for displaying in chat.
 */
export function isActivityRelevantToApp(dl: DirectLine, activity: BotActivity) {
  const directLine = dl as AdsCopilotDirectLine;

  if (directLine.isCustomStream) {
    // custom stream is set, all activities are irrelevant
    return false;
  }

  if (directLine.username && activity.from?.name === directLine.username) {
    // user message, not relevant
    return false;
  }

  if (activity.type === 'event' && activity.name === 'pluginResults') {
    // plugin results used for Reporting Insights feature
    return true;
  }

  if (activity.type === 'message') {
    const features = (activity.value as any)?.Features;
    if (Array.isArray(features) && features.length > 0) {
      // plugin result will have at least 1 feature
      return true;
    }
  }

  return false;
}
